export const SHARE_LABEL = "activation.widget.topics.share.label.text";
export const VOLUME_LABEL = "activation.widget.topics.volume.text";
